<template>
    <div>
        <div class="input-group">
            <div class="custom-control custom-switch">
                <input type="checkbox" :name="field_name" class="custom-control-input" :id="field" v-model="innerValue"
                       @input="update()">
                <label class="custom-control-label" :for="field">{{ label }}</label>
            </div>
            <div class="input-group-addon" v-html="statusClass">
            </div>
        </div>
        <div class="modal fade" ref="confirmationModal" tabindex="-1"
             role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ this.confirmText }}</h5>
                    </div>
                    <div class="modal-footer">
                        <button ref="confirmationModalCancel" type="button" class="btn btn-dark" data-dismiss="modal">Cancel
                        </button>
                        <button ref="confirmationModalContinue" type="button" class="btn btn-danger" data-dismiss="modal">Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "ToggleButton",
    props: {
      onLabel: {
        type: String,
        required: true,
      },
      offLabel: {
        type: String,
        required: true,
      },
      value: {
        type: Boolean,
        required: true,
      },
      field_name: {
        type: String,
        required: true,
      },
      route: {
        type: String,
        required: true,
      },
      requireConfirmation: {
        type: Boolean,
        default: false,
      },
      confirmationText: {
        type: String,
        default: 'Value will be updated to: [value]'
      }
    },
    computed: {
      label() {
        if (!this.innerValue) {
          return this.offLabel;
        }
        return this.onLabel;
      },
      statusClass() {
        if (this.sending) {
          return '<ion-icon name="sync" class="md-hydrated">';
        }
        if (this.dirty) {
          return '<ion-icon name="create" class="md-hydrated">';
        }
        return '<ion-icon name="checkmark" class="md-hydrated">';
      },
      field() {
        return this.field_name + '_' + btoa(this.route);
      },
      confirmText() {
        const value = this.innerValue ? this.onLabel: this.offLabel;
        return this.confirmationText.replace('[value]', value)
      },
    },
    data() {
      return {
        sending: false,
        dirty: false,
        innerValue: this.value,
      };
    },
    watch: {
      innerValue(newValue, oldValue) {
        if (newValue !== undefined && newValue !== oldValue) {
          let self = this;
          const promise = new Promise((resolve, reject) => {
            if (! self.requireConfirmation) {
              return resolve();
            }
            $(self.$refs.confirmationModalCancel).click(reject);
            $(self.$refs.confirmationModalContinue).click(resolve);
            $(self.$refs.confirmationModal).modal('show');
          });

          promise.then(() => {
            self.sendUpdate();
          }).catch(error => {
            self.innerValue = oldValue;
          });
        }
      },
    },
    methods: {
      update() {
        this.$emit('input', this.innerValue);
      },
      sendUpdate() {
        this.dirty = true;
        this.sending = true;
        let data = {};
        data[this.field_name] = this.innerValue;
        axios.patch(this.route, data).then(response => {
          this.sending = false;
          this.dirty = false;
        }).catch(error => {
          this.$toasted.error('Failed to toggle');
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
    .input-group-addon {
        line-height: unset;
    }
</style>
